 <!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->
<span *ngIf="!loading; else loadingSkeleton;">
  <div *ngIf="relativeChange === 0; else nonZero;" class="data-wrapper" [ngClass]="{'default-colors': !useThemeColors}"
       [ngStyle]="{'align-items': alignItems}">
    <div>No change over last week</div>
  </div>
  <ng-template #nonZero>
    <div class="data-wrapper" [ngClass]="{'default-colors': !useThemeColors}"
         [ngStyle]="{'align-items': alignItems}">
      <div>
        <span>{{Math.abs(relativeChange) | percent: '1.0-0'}}&nbsp;</span>
        <span>{{relativeChange > 0 ? "increase" : "decrease"}}</span>
        <span class="mdi arrow-icon" [ngClass]="{'mdi-arrow-down-thin': relativeChange < 0, 'mdi-arrow-up-thin': relativeChange > 0}"></span>
      </div>
      <div>over last week</div>
    </div>
  </ng-template>
</span>
<ng-template #loadingSkeleton>
  <ngx-skeleton-loader
    count="2"
    appearance="line"
    [theme]="themeCssClass">
  </ngx-skeleton-loader>
</ng-template>

